import Modal from 'react-bootstrap/Modal'
import Button from './Button'
import useForm from '../useForm'
import { useParams } from 'react-router-dom'
import usePassword from '../usePassword'
import NotVisible from './Svg/NotVisible'
import Visible from './Svg/Visible'
import BankDetailsModal from './BankDetailsModal'
import { useState } from 'react'

function ValidateBankModal(props) {
    const [bankDetailsModal, setBankDetailsModal] = useState(false);
    const { handleChange, values, errors, errmsg, seterrmsg, message, setMessage} = useForm({
        username: '',
        password:''
        })
        const { token } = useParams();
        const {showPassword,handleShowPassword,  handleHidePassword} = usePassword();

        const verifyBank = async(values, token) => {
            const sendOptions = {
              method : 'POST',
              headers: {
                "Content-Type" : "application/json",
                "Accept": "application/json",
                'Authorization': `Bearer ${token}`
               },
             body: JSON.stringify(values)
            }
            await fetch(`${process.env.REACT_APP_API_URL}/bank/validate`, sendOptions)
            .then (response => response.json())
            .then (data => {
                if (data.msg === 'validated') {
                  setTimeout(() => {
                    setBankDetailsModal(true);
                    setMessage('');
                    seterrmsg('');
                    
                  },2000)
                    setMessage('Account verified');
            } else{
              seterrmsg('Verification unsuccessful, please try again')
            }
            })
            .catch(err => {
              console.log(err)
              seterrmsg('Verification unsuccessful, please try again')
            })
          }
      
          const handleBankVerification = (e) => {
            e.preventDefault()
            verifyBank(values,token)
          }

  return (
    <Modal
    {...props}
    size="md"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
    <Modal.Header closeButton>
    <h6 className='bankmodal-head'> Verify Account</h6>
    </Modal.Header>
    <Modal.Body >
        
     <form onSubmit={handleBankVerification}>
       {message ? <p className='text-success my3 message'>{message}</p> : <p className='text-danger my3 message'>{errmsg}</p>}
    <input  className='bank-input' type="text" placeholder='Username'  name='username' id='username' value={values.username} onChange={handleChange}/>
   
    <div className="password-input-group">
                  <input 
                  className={errors.password ? "error signup-input gen-input" : "signup-input gen-input"}
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  id="login-password"
                  name="password"
                  value={values.password}
                  onChange={handleChange} />
                     {showPassword ?
                <div className="gs-not-visible-group" onClick={handleHidePassword}>
                <NotVisible stroke="#7A8996"/>
              </div> : 
              <div className="gs-visible-group" onClick={handleShowPassword}>
              <Visible fill="#7A8996" />
            </div>}
              </div>
              {errors.password && <p className="small">{errors.password}</p>}

    <div className="bv-btn-group">
    <Button disabled={errors.password || errors.email } type='submit'>
        Save
    </Button>
    </div>
  </form>
     
    </Modal.Body>
    <BankDetailsModal  show={bankDetailsModal}
        onHide={() => setBankDetailsModal(false)}  ></BankDetailsModal>
  </Modal>
  )
}

export default ValidateBankModal